import api from "services/api";

// Get
export const getSalaryConfigurations = async () => {
  return api.get("/v1/api/employee-salary-config/list");
};

// Create
export const createSalaryConfiguration = async (configData) => {
  return api.post("/v1/api/employee-salary-config/create", configData);
};

// Update
export const updateSalaryConfiguration = async (configId, configData) => {
  return api.put(
    `/v1/api/employee-salary-config/update/${configId}`,
    configData,
  );
};

// Approve employee salary configuration
export const approveSalaryConfiguration = async (configId) => {
  return api.patch(`/v1/api/employee-salary-config/approve/${configId}`);
};

// Delete
export const deleteSalaryConfiguration = async (configId) => {
  return api.delete(`/v1/api/employee-salary-config/delete/${configId}`);
};
